<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><a href="javascript:history.back()" class="voltar"><img class="imgVoltar" :src="imgVoltar"></a>Criar Lembrete de Medicação</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>

                            <v-text-field name="titulo" label="Título" type="text"
                                          v-model="titulo" required>
                            </v-text-field>
                            
                            <v-text-field name="texto" label="Descrição completa com horários, medicação e quantidade." type="text"
                                          v-model="texto" required>
                            </v-text-field><br />

                            <label class="v-label theme--light">Aluno:</label>
                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsAlunos"
                                        item-value="alunoSlug"
                                        item-text="alunoName"
                                        return-object
                                        v-model="aluno"
                                    ></v-select>
                                </v-card-text>
                            </v-flex><br />

                            
                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-menu
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="menu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :nudge-right="40"
                                    max-width="290px"
                                    min-width="290px"
                                    >
                                    <v-text-field
                                        slot="activator"
                                        label="Data Inicio"
                                        v-model="dateStart"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker v-model="dateStart" no-title scrollable actions>
                                        <!-- <template scope="{ save, cancel }"> -->
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <!--v-btn flat color="primary" @click="cancel">Cancel</v-btn-->
                                            <v-btn class="buttonOk" flat color="primary" @click="save">OK</v-btn>
                                        </v-card-actions>
                                        <!-- </template> -->
                                    </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-menu
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="menu2"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :nudge-right="40"
                                    max-width="290px"
                                    min-width="290px"
                                    >
                                    <v-text-field
                                        slot="activator"
                                        label="Data Fim"
                                        v-model="dateEnd"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker v-model="dateEnd" no-title scrollable actions>
                                        <!-- <template scope="{ save, cancel }"> -->
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <!--v-btn flat color="primary" @click="cancel">Cancel</v-btn-->
                                            <v-btn class="buttonOk" flat color="primary" @click="save">OK</v-btn>
                                        </v-card-actions>
                                        <!-- </template> -->
                                    </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>                            
                            
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="criarLembreteMedicacao" data-cy="joinSubmitBtn">Criar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask'

import { userProperties, pushNotificationSettings } from '@/global.js'

import axios from 'axios'
import VueAxios from 'vue-axios'

import imgVoltar from '../assets/ic-voltar.png';

//Vue.use(VueAxios, axios)

export default {
    name: 'Criar-Lembrete-Medicacao',
    directives: {mask},
    
    data: vm => ({
        imgVoltar: imgVoltar,
        valid: false,
        titulo: null,
        texto: null,
        link: null,
        timestamp: null,
        dialog: false,
        loading: false,
        slug: null,
        extensao : null,
        statusUpload: true,
        tituloModal: "Lembrete de medicação criado com sucesso!",
        dateStart: new Date().toISOString().substr(0, 10),
        dateEnd: new Date().toISOString().substr(0, 10),
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        preview: false,
        pushIDs: null,
        push: false,
        textoPush: null,
        menu: false,
        menu2: false,
        exibicao: {
                value: {
                    exibicaoID: 1,
                    exibicaoName: 'Modal'
                }
            },
        itemsExibicao: [
            {
                value: {
                    exibicaoID: 1,
                    exibicaoName: 'Modal' // Aparece na timeline e na listagem
                },
                text: 'Modal'
            },
            // {
            //     value: {
            //         exibicaoID: 2,
            //         exibicaoName: 'Disclaimer'  // Aparece na timeline e na listagem
            //     },
            //     text: 'Disclaimer'
            // },
            {
                value: {
                    exibicaoID: 2,
                    exibicaoName: 'Somente listagem' // Aparece na timeline e na listagem
                },
                text: 'Somente listagem'
            }
        ],
        aluno: {
                // alunoSlug: 1,
                // alunoName: 'Alice'
        },
        itemsAlunos: [
            // {
            //         alunoSlug: 0,
            //         alunoName: 'Laura'
            // },
            // {
            //         alunoSlug: 1,
            //         alunoName: 'Alice'
            // }
        ],
        alunoSlug: null
    }),
    // computed: {
    //     computedDateFormatted () {
    //         return this.formatDate(this.dateStart)
    //     }
    // },
    // watch: {
    //     date (val) {
    //         this.dateFormatted = this.formatDate(this.dateStart)
    //     }
    // },
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        formatDate (dateStart) {
            if (!dateStart) return null

            const [year, month, day] = dateStart.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (dateStart) {
            if (!dateStart) return null

            const [month, day, year] = dateStart.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        save() {
            this.menu = false;
            this.menu2 = false;
        },
        criarLembreteMedicacao(){

            // Log do sistema
            if(userProperties.escolaID != null){            
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('log_' + userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        perfil: userProperties.perfil,
                        
                        slug: this.slug,
                        customtimestamp: customtimestamp,
                        dia: day,
                        mes: month,
                        ano: year,
                        acao: "criar",
                        categoria: "medicacao",
                        pontos: 10
                        
                    })
                    .then(docRef => {
                        console.log('Document written with ID: ', docRef.id);

                        
                    })
                    .catch(function (error) {
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }


            this.textoPush = "Criado por " + userProperties.nome + " para o aluno " + this.aluno.alunoName;

            if(userProperties.escolaID != null){
                this.loading = true
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('medicacao').add({
                        nome: userProperties.nome,
                        imagemPerfil: userProperties.imagem,
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        
                        slug: this.slug,
                        customtimestamp: customtimestamp,
                        titulo: this.titulo,
                        texto: this.texto,
                        dateStart: this.dateStart,
                        dateEnd: this.dateEnd,
                        textoPush: this.textoPush,
                        aluno: this.aluno
                        
                    })
                    .then(docRef => {

                            console.log("entrou no if de enviar push");
                            var postData = {
                                "notification": {        
                                    "title": "Novo lembrete de medicamento!",
                                    "body": "Verifique os detalhes na lista de medicamentos.",
                                    "click_action": "https://inclass.app",
                                    "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                    "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                    //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                    "sound": "default"
                                },    
                                //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                                "to": this.pushIDs
                            }

                            let axiosConfig = {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "Authorization": pushNotificationSettings.authorization,
                                }
                            };

                            axios.post(pushNotificationSettings.urlFCM, postData, axiosConfig)
                            .then((res) => {
                                console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                            })
                            .catch((err) => {
                                console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                            })

                        

                        console.log('Document written with ID: ', docRef.id);
                        //this.$router.push(`/${slug}/success`)
                        this.loading = false
                        this.dialog = true
                        
                    })
                    .catch(function (error) {
                        this.loading = false
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
            
        },
        closeModal(){
            this.$router.push(`/lembrete-medicacao-listagem`);
        },        
        submit() {
            if (this.$refs.form.validate() && this.statusUpload == true) {
            }
            if (this.$refs.form.validate() && this.statusUpload == false) {
                alert("Por favor, faça o upload da foto do perfil do usuário")
            } 
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        }
        
    },
    mounted() {
        const slug = this.generateUUID()
        this.slug = slug;

        var that = this;

        // Pega todos os token FCM dos professores para enviar o push. Obs: tem duas chamadas para fazer OR condition
        var tokensFMC = "";
        db.collection('usuarios').where("escolaID", "==", userProperties.escolaID)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                console.log(doc.id, " => ", doc.data());               
                let customObj = doc.data()
                if(customObj.tokenFMC != undefined && customObj.tokenFMC != "")
                    tokensFMC = tokensFMC + customObj.tokenFMC + ",";
            });

            
            this.pushIDs = tokensFMC;

            

        });

        
        // Lista de alunos
        this.itemsAlunos = []
        this.loading = true
        
        db.collection("usuarios")
        .where("escolaID", "==", userProperties.escolaID).where("perfil", "==", 7)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                
                // doc.data() is never undefined for query doc snapshots
                //console.log(doc.id, " => ", doc.data());                    
                let customObj = doc.data()
                
                    // ######## Listar somente filhos do responsavel logado
                    userProperties.alunos.forEach(function(item, index){
                        if(item.alunoSlug == customObj.slug){
                            that.itemsAlunos.push({"alunoName": customObj.nome, "alunoSlug": customObj.slug});
                        }
                    });
                    
                    this.alunoSlug = customObj.slug;
                    this.loading = false

                 
                
            });
        });
        //console.log(this.itemsAlunos);

    }
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }

    .btCirculo{
        height: 30px;
        width: 30px;
    }

    .btCirculo a{
        color:#fff;
    }

    progress{
        width:100%;
        margin-top: 6px;
    }

    label.v-label.theme--light{
        margin-bottom: 6px;
        display: block
    }

    .adicionarItem.btCirculo{
        position: relative;
        top: 12px;
        left: 5px;
    }

    .excluirItem.btCirculo{
        position: relative;
        left: 5px;
        top:-10px;
    }

    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }

    .container{
        padding: 0 0 !important;
    }

    .buttonOk{
        position: absolute;
        right: 2px;
        bottom: 5px;
    }
</style>
